<div class="data-from-argus-dialog" [class.close]="shouldClose" [class.canClose]="canClose" *ngIf="properties">
  <div class="data-from-argus-dialog-container">
    <div *ngIf="canClose" class="closeButton" (click)="closeClicked()"></div>
    <div class="upper-text">
      <h2>{{ 'dataFromArgusDialog.title' | translate}}</h2>
    </div>

    <section class="mainSection main-content" *ngIf="isConfirmationPopup">
      <div>
        {{ 'dataFromArgusDialog.confirmDialogMessagePart1' | translate}}
      </div>
      <ng-container *ngFor="let property of properties">
        <div class="property">
          {{ 'dataFromArgusDialog.assetPropertyId' | translate}} {{ property.argusPropAssetId }} - {{ property.propertyName }}
        </div>
      </ng-container>
      <div>
        {{ 'dataFromArgusDialog.confirmDialogMessagePart2' | translate}}
      </div>
      <div class="buttons-container">
        <button kendoButton (click)="continue()">{{'dataFromArgusDialog.continue' | translate}}</button>
      </div>
    </section>

    <section class="mainSection main-content" *ngIf="isSuccess">
      <div>
        {{ 'dataFromArgusDialog.successMessage' | translate}}
      </div>
      <div class="buttons-container">
        <button kendoButton (click)="closeClicked()">{{'dataFromArgusDialog.close' | translate}}</button>
      </div>
    </section>

    <section class="mainSection" *ngIf="isFailed">
      <div>
        {{ 'dataFromArgusDialog.errorMessagesPart1' | translate}}
      </div>
      <ng-container *ngFor="let errorMessage of errorMessages">
        <div class="errorMessage">
          {{ errorMessage.message}}
        </div>
      </ng-container>
      <div>
        {{ 'dataFromArgusDialog.errorMessagesPart2' | translate}}
      </div>
      <div class="buttons-container">
        <button kendoButton (click)="closeClicked()">{{'dataFromArgusDialog.close' | translate}}</button>
      </div>
    </section>
  </div>
</div>
